$(document).ready(function () {
  var formFields = $('[data-form-field]');
  var formFieldSignUp = $('[data-form-sign-up]');

  formFields.each(function (formField) {
    var $formField = $(this);
    var $fieldInput = $($formField).find(".input");

    if ($fieldInput.val().length) {
      $($formField).addClass("field--has-value");

    } else {
      $($formField).removeClass("field--has-value");
    }


    $($fieldInput).focus(function () {
      $(this).addClass("input--focused");
      $($formField).addClass("field--focused");
    });

    $($fieldInput).blur(function () {
      $(this).removeClass("input--focused");
      $($formField).removeClass("field--focused");
    });

    $($fieldInput).change(function () {
      var fieldValue = $(this).val();
      var $inputType = $(this).attr("type");

      if ($inputType === "email") {
        var emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        var emailIsValid = emailRegex.test(fieldValue);
        var $formFieldErrorElement = $($formField).find(".field__error");

        if (!emailIsValid) {
          $($formFieldErrorElement).html("Please enter a valid email address.");
          $($formFieldErrorElement).addClass("field__error--show")
        } else {
          $($formFieldErrorElement).removeClass("field__error--show")
        }
      }

      if (fieldValue.length) {
        $($formField).addClass("field--has-value");

      } else {
        $($formField).removeClass("field--has-value");
      }

    });
  });

  formFieldSignUp.each(function(){
    $(this).closest('form').addClass('gtm-newsletter-subscribe');

    formFieldSignUp.on('change', this, function(){
      if ($(this).is(':checked')) {
        $(this).closest('form').addClass('gtm-newsletter-subscribe');
      }else{
        $(this).closest('form').removeClass('gtm-newsletter-subscribe');
        //$form.removeClass('gtm-newsletter-subscribe');
      }

    })

  });

  $('[data-prefered-phone]').on('click', function () {
    $('[data-prefered-phone-required]').prop('required', true);
    $('[data-phone-label]').html('Phone*');
    $('#PhoneDiv').show();
  });

  $('[data-prefered-email]').on('click', function () {
    $('[data-prefered-phone-required]').removeAttr('required');
    $('[data-phone-label]').html('Phone');
    $('#PhoneDiv').hide();
  });
  
  $('[data-enquiry-type-retail]').on('click', function () {
    $("[data-enquiry-type-field]").removeClass('mb-10');
    $("[data-enquiry-type-field]").addClass('mb-30');
    $("[data-company-field]").hide();
  });
  $('[data-enquiry-type-commercial], [data-enquiry-type-trade]').on('click', function () {
    $('[data-enquiry-type-field]').removeClass('mb-30');
    $('[data-enquiry-type-field]').addClass('mb-10');
    $('[data-company-field]').show();
  });
});